import React from 'react';
import { Box, Button, Typography, List, ListItem, ListItemText } from '@mui/material';
import { useDataFunctions } from '../../contexts/Data';

export default function Reports({ target_object, ...rest }) {
  const data = useDataFunctions();
  const [availableReports, setAvailableReports] = React.useState([]);

  // Async function to trigger file download with custom filename
  const downloadReport = async (reportId) => {
    const report = availableReports.find(r => r.id === reportId);
    // set the downloading state to true
    const updatedReports = availableReports.map(r => (r.id === reportId ? { ...r, downloading: true } : r));
    setAvailableReports(updatedReports);
    if (!report || !report.pre_signed_url) {
      console.error('Report not found or missing pre_signed_url');
      return;
    }
    
    // Construct the desired file name using data from the report
    const fileName = `${report.filename}.${report.type}`;
    
    try {
      // Fetch the file as a blob to override any S3 headers
      const response = await fetch(report.pre_signed_url);
      if (!response.ok) {
        throw new Error(`Error fetching report: ${response.statusText}`);
      }
      const blob = await response.blob();
      
      // Create an object URL from the blob
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Create a temporary link element and trigger the download
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      
      // Clean up by removing the link element and revoking the blob URL
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed:', error);
    }
    // set the downloading state to false
    const finalReports = availableReports.map(r => (r.id === reportId ? { ...r, downloading: false } : r));
    setAvailableReports(finalReports);
  };

  React.useEffect(() => {
    data.getAvailableReports()
      .then((result) => {
        // add a "downloading" key to each report object
        const reportsWithDownloadKey = result.available_reports.map(report => ({
          ...report,
          downloading: false,
        }));
        // set the state with the modified reports
        setAvailableReports(reportsWithDownloadKey || []);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Reports
      </Typography>
      <List>
        {availableReports.map((report) => (
          <ListItem
            key={report.id}
            secondaryAction={
              <Button
                variant="contained"
                onClick={() => downloadReport(report.id)}
                disabled={report.downloading}
              >
                {report.downloading ? 'Downloading...' : 'Download'}
              </Button>
            }
          >
            <ListItemText primary={report.name} />
          </ListItem>
        ))}        
      </List>
    </Box>
  );
}
